export const NewRequest = ({ color, size, fill }) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28 14.5C28 7.04688 21.9531 1 14.5 1C7.04688 1 1 7.04688 1 14.5C1 21.9531 7.04688 28 14.5 28C21.9531 28 28 21.9531 28 14.5Z"
        stroke={color}
        fill={fill ? color : undefined}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M14.5 8.875V20.125"
        stroke={fill ? "white" : color}
        fill={fill ? color : undefined}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.127 14.5H8.87695"
        stroke={fill ? "white" : color}
        fill={fill ? color : undefined}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
